var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "news-card-wrapper pb-md-0",
      on: {
        click: function($event) {
          return _vm.navigateToNewsPost()
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "card-img-wrapper col-12 col-md-3 pb-3 pb-md-0" },
          [
            _vm.imgUrl
              ? _c("img", {
                  staticClass: "card-img mr-4",
                  attrs: { src: _vm.imgUrl, alt: _vm.postData.title },
                  on: { error: _vm.handleImgLoadError }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-9 pl-md-1" }, [
          _c(
            "div",
            [_c("news-card-details", { attrs: { date: _vm.postData.date } })],
            1
          ),
          _vm._v(" "),
          _c("div", [_c("h3", [_vm._v(_vm._s(_vm.postData.title))])]),
          _vm._v(" "),
          _vm.showInterestTag
            ? _c(
                "div",
                { staticClass: "d-inline-block" },
                [_c("interest-tag", { attrs: { title: _vm.postData.topic } })],
                1
              )
            : _c(
                "div",
                { staticClass: "d-inline-block" },
                [
                  _c("categories-tag", {
                    attrs: { categories: _vm.postData.categories }
                  })
                ],
                1
              )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-834b5720", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-834b5720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/newsByInterests/NewsFeedCard.vue
// module id = null
// module chunks = 